<template>
    <div class="tab_content">
        <!-- <img src="/fake/品牌汇总表.png" alt=""> -->
        <div class="">
            <div class="group">
                <div :class="['item', brand_ids.indexOf(item.id) < 0 ? '': 'checked' ]" v-for="(item, index) in brandList" :label="item.id" :key="`brand_${index}`" @click="check(item.id)">
                    {{ item.name }}
                </div>
                <el-checkbox class="check_all_item" v-model="is_all" @change="checkAll">全选</el-checkbox>
            </div>
        </div>
        <div class="flex_1 tableFlex clearfix">
            <!-- <vue-waterfall-easy ref='waterfall' id="pic" :imgsArr="list" :imgWidth="564" @scrollReachBottom="getData" :gap="10">
                <div slot="waterfall-over"></div>
                <div class="img-info" slot-scope="{value, index}">
                    
                </div>
            </vue-waterfall-easy> -->
            <div class="img-info" v-for="(value,index) in list" :key="index">
                <table border="1">
                    <thead>
                        <tr>
                            <th :class="`col_${colIndex+1}`" v-for="(item, colIndex) in value.col" :key="`col${index}${colIndex}`">{{item}}</th>
                        </tr>
                    </thead>
                    <tbody v-for="(item, listIndex) in value.list" :key="`col${index}${listIndex}`">
                        <tr v-for="(data, itemIndex) in item.list" :key="`col${index}${listIndex}${itemIndex}`">
                            <td :rowspan="item.list.length" v-if="itemIndex == 0">{{item.grade}}</td>
                            <td v-for="(d, dataIndex) in data" :key="`col${index}${listIndex}${itemIndex}${dataIndex}`">{{d}}{{ dataIndex == 3 ? 'm³' : '' }} </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td>合计</td>
                            <td colspan="4">{{value.total.cube}} <span class="red">({{value.total.count}}件)</span>  </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
    .group{
        display: flex; flex-wrap: wrap;
        .item{ min-width:85px; height:36px; line-height: 36px; text-align: center; padding: 0 12px; border-radius:3px; border:1px solid rgba(102,102,102,1); cursor: pointer; margin: 6px; }
        .item.checked{
            border:1px solid rgba(178,17,17,1); position: relative; color: #B21111;
            &::after{ display: block; content: ""; width:21px; height:21px; position: absolute; right: 0; bottom: 0; background: url("/icon/checkeded.png") no-repeat; background-size: cover; }
        }
        .check_all_item{ height:36px; line-height: 36px; text-align: center; margin: 6px; }
    }
    .flex_1{ flex: 1; }
    .img-info{float: left;margin:10px;
        table{
            border-collapse: collapse; white-space: nowrap; font-size: 14px; text-align: center;
            td{ height:42px; }
            .col_1{ width:168px; height:42px; background:rgba(178,17,17,1); color: #fff; }
            .col_2{ width:100px; height:42px; }
            .col_3{ width:100px; height:42px; }
            .col_4{ width:100px; height:42px; }
            .col_5{ width:100px; height:42px; }
            tfoot {
                td{ border: 0px none; }
            }
        }

    }
    .tableFlex{width:100%;height: 100%;overflow: auto;flex-flow: column wrap;}
</style>
<script>
    // import vueWaterfallEasy from 'vue-waterfall-easy'

    export default {
        components:{
            // vueWaterfallEasy
        },
        data(){
            return{
                list : [],
                brand_ids: [],
                brandList : [],
                is_all : true,
            }
        },
        created(){
            
        },
        methods:{
            check(id){
                let index = this.brand_ids.indexOf(id);
                if(index < 0){
                    this.brand_ids.push(id);
                } else {
                    this.brand_ids.splice(index, 1);
                }
                this.is_all = this.brand_ids.length === this.brandList.length;
            },
            getBrandList(){
                this.$getBrandList().then(res=>{
                    this.brandList = res.data.data;
                    this.checkAll(true)
                    // this.brand_ids.push(res.data.data[0].id)
                })
            },
            async getList(){
                await this.getBrandList();
                // await this.getData();
            },
            getData(){
                this.postFuncLoading("/erp/report.inventory.brand",{
                    brand_ids : this.brand_ids
                },response=>{
                    if(response.data.code == 0){
                        this.list = response.data.data
                    }
                })
            },
            checkAll(value){
                if(value){
                    this.brand_ids = this.brandList.map( (item) => {
                        return item.id;
                    })
                } else {
                    this.brand_ids = [];
                }
            }
        },
        watch:{
            'brand_ids':function(){
				this.getData();
			},
        }
    }
</script>
